import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { HttpParams } from "@angular/common/http";
import { Params, Router } from "@angular/router";
import Swal from "sweetalert2";
import { ReportsService } from "src/app/features/reports/reports.service";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { DialogComponent } from "src/app/features-common/components/dialog/dialog.component";
import { MatTabGroup } from "@angular/material/tabs";
import { CurrencyPipe, formatDate } from "@angular/common";
import * as moment from "moment";
import { AdminViewService } from "src/app/framework/services/admin-view.service";

@Component({
  selector: "app-payment-report",
  templateUrl: "./payment-report.component.html",
  styleUrls: ["./payment-report.component.scss"],
  providers: [CurrencyPipe],
})
export class PaymentReportComponent
  extends FeaturesBaseComponent
  implements OnInit, OnChanges
{
  @Input() payments;
  @Input() summary;
  @Input() startDate;
  @Input() endDate;
  isRowSelected: boolean = false;
  searchValue: any;

  columnDefs: any;
  rowData: any;
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  isLogSelected: boolean;

  minFromDate;
  maxDate;
  minToDate;
  isButtonDisabled:boolean
  

  constructor(
    private reportsService: ReportsService,
    private currencyPipe: CurrencyPipe,
    private adminViewServices:AdminViewService
  ) {
    super();
    this.setGrid();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["payments"]) {
      this.payments = changes["payments"].currentValue;
      this.rowData = this.payments;
    }
    if (changes["summary"]) {
      this.summary = changes["summary"].currentValue;
    }
  }

  setGrid() {
    const self = this;
    this.columnDefs = [
      {
        field: "dateRequested",
        headerName: "Date Requested",
        width: 250,
        cellRenderer: (data) => {
          return moment(data.value).format("MM/DD/YYYY");
        },
      },
      {
        field: "amountPaid",
        headerName: "Amount",
        width: 180,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      { field: "retailerName", headerName: "Retailer Name(DBA)", width: 230 },
      { field: "paymentType", headerName: "Payment Type", width: 200 },
      { field: "bankName", headerName: "Bank Name", width: 210 },
      {
        field: "paymentStatus",
        headerName: "Payment Status",
        width: 210,
        cellRenderer: (params) => {
          return params.value == "Pending Approval"
            ? `Pending`
            : params.value;
        }
      },
      {
        field: "paymentStatus",
        headerName: "",
        width: 135,
        cellRenderer: (params) => {
          return params.value == "Pending Approval" && (params.data.paymentType == "ACH" || params.data.paymentType == "Deposit" )
            ? `<span class="rounded-pill bg-main text-white px-2 py-1 cur-point">Approve</span>`
            : '';
        },
        onCellClicked: function (params) {
          if (params.value == "Pending Approval") {
            self.handleApprove(params.data);
          }
        },
      },
      {
        field: "paymentType",
        headerName: "",
        width: 120,
        cellRenderer: (params) => {
          return params.value == "Deposit" && params.data.paymentStatus == "Pending Approval"
            ? `<span class="rounded-pill bg-danger text-white px-2 py-1 cur-point">Reject</span>`
            : '';
        },
        onCellClicked: function (params) {
          if (params.value == "Deposit") {
            self.handleReject(params.data);
          }
        },
      },
      { field: "tellerNumber", headerName: "Teller Number", width: 250 },
      { field: "transactionNumber", headerName: "Transaction Number", width: 270 },
      { field: "depositDate", headerName: "Deposit Date", width: 270,
      cellRenderer: (params) => {
        if(params.value == null){
          return
        }else{ 
          return params.data.paymentType == 'Deposit' ?  params.value : moment(params.value).format("MM/DD/YYYY");
          //2021-08-09T18:30:00.000+00:00
        }
      }, },
      { field: "depositTime", headerName: "Deposit Time", width: 270},
      { field: "achBankAccountNumber", headerName: "ACH Bank Account Number", width: 300 },
      { field: "achRoutingNumber", headerName: "ACH Routing Number", width: 300 },
      { field: "savingChacking", headerName: "Savings/Checking", width: 220 },
      {
        field: "retailerAccountNumber",
        headerName: "Retailer Account Number",
        width: 290,
      },
      { field: "invoiceNumber", headerName: "Invoice Number", width: 210 },
      {
        field: "settlementDate",
        headerName: "Settlement Date",
        width: 250,
        cellRenderer: (params) => {
          return params.data.paymentType == 'Deposit' ?  params.data.depositDate : moment(params.value).format("MM/DD/YYYY");
        },
      },
        
      { field: "salesRepName", headerName: "Sales Rep/Dist", width: 220 },
      
      { field: "bankCode", headerName: "Bank Code", width: 180 },
      { field: "autoReloadStatus", headerName: "Auto Payment Status", width: 240 },
      



      

      { field: 'fileURL', headerName: 'File', width: 180, cellRenderer: (params) => { return params.data.fileURL && params.data.fileURL ? `Download` :"" },
      onCellClicked: function (params) { self.handleAttachment(params.data); }
      },
      {
        field: "statusUpdatedDttm",
        headerName: "Approved Time",
        width: 250,
        cellRenderer: (data) => {
          if(data.value == null){
            return
          }else{ 
            return moment(data.value).format("MM/DD/YYYY hh:mm:ss:a"); 
          }
        },
      },
      {
        field: "approvedBy",
        headerName: "Approved By",
        width: 250,
      },
      {
        field: "confirmationNumber",
        headerName: "Confirmation Number",
        width: 250,
      },
      {
        field: "retialerAccountType",
        headerName: "Retailer Account Type",
        width: 280,
      },
    ];
  }
  //
  handleAttachment(data: any) {
    if(data.fileURL != null){
      window.open(data.fileURL)
    }    
  }  
  
  exportData() {
    let header = this.columnDefs.map((columnDef) => {
      let headerName = columnDef.headerName;
      return headerName;
    });
    let params: any = {
      fileName: "Payment-Report.csv",
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs
        .map((c) => c.field || c.colId)
        .filter((c) => !!c),
    };
    params.customHeader = header.join(params.columnSeparator);
    params.processCellCallback = (cellParams) => {
      // 
      if(cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      }else if (
        (cellParams && cellParams.column.colId === "dateRequested") ||
        cellParams.column.colId === "settlementDate" ||
        cellParams.column.colId === "depositDate"
      ) {
        if(cellParams.value === null) return
        return moment(cellParams.value).format("MM/DD/YYYY"); //apply your timestamp formatter
      } else if (cellParams && cellParams.column.colId === "amountPaid") {
        return this.currencyPipe.transform(cellParams.value);
      } else return cellParams.value; // no formatting
    };
    this.gridApi.exportDataAsCsv(params);
  }

  handleApprove(rowData) {
   
    if (rowData.retailerPaymentId && rowData.retailerPaymentId) {
      this.reportsService
        .approveACHDD(rowData.retailerPaymentId)
        .subscribe((res) => {
          if (res["httpcode"] == 200) {
            this.toastrService.success(`Payment Approved!`, `Success`);
            let params: any = new HttpParams()
              .set("startDate", this.startDate)
              .set("endDate", this.endDate);
            this.reportsService.getPayments(params).subscribe((res) => {
              let resData: any = res;
              if (resData.httpcode == 200) {
                resData = resData.data;
                this.payments = resData;
                this.rowData = this.payments;
              }
            });
          }
         
        });
    }
  }
  handleReject(rowData) {
   
    if (rowData.retailerPaymentId && rowData.retailerPaymentId) {
      this.reportsService
        .rejectACHDD(rowData.retailerPaymentId)
        .subscribe((res) => {
          if (res["httpcode"] == 200) {
            this.toastrService.success(`Payment Rejected!`, `Success`);
            let params: any = new HttpParams()
              .set("startDate", this.startDate)
              .set("endDate", this.endDate);
            this.reportsService.getPayments(params).subscribe((res) => {
              let resData: any = res;
              if (resData.httpcode == 200) {
                resData = resData.data;
                this.payments = resData;
                this.rowData = this.payments;
              }
            });
          }
         
        });
    }
  }
  ngOnInit(): void {
    super.ngOnInit();
     this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })
  }
  // retailerPaymentId

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
  }
  onSelectionChanged(e) {
    //;
    this.selectedRows = this.gridApi.getSelectedRows();
    if (
      this.selectedRows &&
      this.selectedRows != [] &&
      this.selectedRows.length! > 0
    ) {
      this.isLogSelected = true;
      return;
    }
    this.isLogSelected = false;
  }
  changeFromDate(e) {
    this.minToDate = e.value;
    this.startDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.endDate != null && this.endDate != undefined) {
      this.getDateChangeResult(this.startDate, this.endDate);
    }
  }
  changeToDate(e) {
    this.endDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.startDate != null && this.startDate != undefined) {
      this.getDateChangeResult(this.startDate, this.endDate);
    }
  }

  getDateChangeResult(startDate, endDate) {
    let params: any = new HttpParams()
      .set("startDate", startDate)
      .set("endDate", endDate);
    this.reportsService.getpaymentSummary(params).subscribe((res) => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        this.summary = resData.data;
        this.reportsService.getPayments(params).subscribe((res) => {
          let resData: any = res;
          if (resData.httpcode == 200) {
            this.payments = resData.data;
            this.setRowData(res["data"]);
          }
        });
      }
    });
  }

  setRowData(rowData: any) {
    this.rowData = rowData;
  }
}
